import { useQuery } from '@tanstack/react-query';
import { jobsQueryOptions } from '@/lib/api';

/**
 * Issues an unconditional jobs query (no `enabled` guard).
 * Must only be called within the authenticated + profile-complete tree,
 * i.e. inside a component rendered by DashboardProvider.
 */
export const useJobs = () => {
  const { data } = useQuery(
    jobsQueryOptions({ page: 1, pageSize: 200, status: null }),
  );

  return data?.jobs ?? [];
};
